import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function createPaymentOrder({ planId, couponCode }) {
  const body = { plan_id: planId };
  if (couponCode?.trim()) body.coupon_code = couponCode.trim();

  return apiRequest('/api/payments/create_order', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
}

export async function createPaymentLink({ planId, couponCode, callbackUrl, redirectUrl }) {
  const body = { plan_id: planId };
  if (couponCode?.trim()) body.coupon_code = couponCode.trim();
  if (callbackUrl?.trim()) {
    body.callback_url = callbackUrl.trim();
    body.callback_method = 'get';
  }
  // Backend may ignore these today; useful when they redirect after payment_link_callback.
  if (redirectUrl?.trim()) {
    body.redirect_url = redirectUrl.trim();
    body.frontend_redirect_url = redirectUrl.trim();
    body.success_url = redirectUrl.trim();
  }

  return apiRequest('/api/payments/create_payment_link', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
}

export async function verifyPayment({
  subscriptionId,
  razorpayOrderId,
  razorpayPaymentId,
  razorpaySignature,
}) {
  return apiRequest('/api/payments/verify', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      subscription_id: subscriptionId,
      razorpay_order_id: razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature: razorpaySignature,
    }),
  });
}

export async function getUserSubscriptions() {
  return apiRequest('/api/payments/subscriptions', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
